import {
  F,
  compose,
  find,
  ifElse,
  isNil,
  pipe,
  prop,
  propEq,
} from 'ramda'
import Loader from '../widgets/Generic/Loader'
import React from 'react'
import { componentDidMount } from '../components/Lifecycles'
import { connect } from 'react-redux'
import { loadScript } from '../store/modules/scripts'

const mapStateToProps = (state, props) => ({
  ready: pipe(
    find(propEq(props.src, 'src')),
    ifElse(isNil, F, prop('ready')),
  )(state.scripts.scripts),
})

const mapDispatchToProps = dispatch => ({
  loadScript: compose(dispatch, loadScript),
})

// didMount :: Props -> Action
const didMount = ({ loadScript, src }) => loadScript(src)

const View = ({ ready, loaderSize, children, className = '' }) => ready
  ? children
  : <Loader size={ loaderSize } className={ className } />

// lifecycles :: React.Component -> React.Component
const lifecycles = componentDidMount(didMount, true)(View)

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(lifecycles)
